import { Grid, Typography } from "@mui/material";
import React from "react";

interface IProps {
  label: string;
  value: React.ReactNode;
}

const InfoItem: React.FC<IProps> = ({ label, value }) => {
  return (
    <>
      <Grid item xs={6}>
        <Typography
          fontSize={{ xs: "12", lg: "14px" }}
          fontWeight={600}
          lineHeight={"19.2px "}
          color={"#98A2B3"}
        >
          {label}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography
          fontSize={{ xs: "12 !important", lg: "14px" }}
          fontWeight={600}
          lineHeight={"19.2px "}
          color={"#101828"}
        >
          {value}
        </Typography>
      </Grid>
    </>
  );
};

export default InfoItem;
